module.exports = __webpack_public_path__ + "static/media/MAYAPPA-PATIL.e8146ea2.png";